document.documentElement.classList.remove('no-js');

const menuToggle = document.querySelector('[data-menu-toggle]');
const mobileNav = document.querySelector('[data-mobile-nav]');
menuToggle?.addEventListener('click', () => {
  const open = menuToggle.getAttribute('aria-expanded') === 'true';
  menuToggle.setAttribute('aria-expanded', String(!open));
  mobileNav?.classList.toggle('is-open', !open);
});

function showCartToast(message) {
  let toast = document.querySelector('[data-cart-toast]');
  if (!toast) {
    toast = document.createElement('div');
    toast.dataset.cartToast = '';
    toast.className = 'cart-toast';
    toast.setAttribute('role', 'status');
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.classList.add('is-visible');
  window.clearTimeout(showCartToast.timeout);
  showCartToast.timeout = window.setTimeout(() => toast.classList.remove('is-visible'), 2200);
}

function bindQuickAdd(root = document) {
  root.querySelectorAll('[data-quick-add]').forEach((button) => {
    if (button.dataset.quickAddBound === 'true') return;
    button.dataset.quickAddBound = 'true';
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      button.disabled = true;
      const original = button.innerHTML;
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }),
        });
        if (!response.ok) throw new Error('Unable to add item');
        const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        button.textContent = '✓';
        showCartToast(document.documentElement.lang.startsWith('zh') ? '已加入购物袋' : 'Added to cart');
      } catch (error) {
        button.textContent = '!';
        showCartToast(document.documentElement.lang.startsWith('zh') ? '暂时无法加入，请重试' : 'Could not add. Please try again.');
      } finally {
        window.setTimeout(() => { button.innerHTML = original; button.disabled = false; }, 1100);
      }
    });
  });
}

bindQuickAdd();

document.querySelectorAll('select[data-default]').forEach((select) => {
  const defaultValue = select.dataset.default;
  if (defaultValue && [...select.options].some((option) => option.value === defaultValue)) {
    select.value = defaultValue;
  }
});

function formatCartMoney(value, currency = 'USD') {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
    }).format(Number(value || 0) / 100);
  } catch (error) {
    return `$${(Number(value || 0) / 100).toFixed(2)}`;
  }
}

document.querySelectorAll('[data-cart-page]').forEach((cartPage) => {
  const form = cartPage.querySelector('[data-cart-form]');
  if (!form) return;
  const currency = cartPage.dataset.cartCurrency || 'USD';
  const checkoutBar = cartPage.querySelector('.cart-summary--sticky');
  const checkoutButton = form.querySelector('[data-cart-checkout]');
  const checkoutLabel = checkoutButton?.textContent;
  let pendingUpdates = 0;
  const syncCheckoutState = () => {
    if (!checkoutButton) return;
    checkoutButton.disabled = pendingUpdates > 0 || !cartPage.querySelector('[data-cart-line]');
    checkoutButton.textContent = pendingUpdates > 0 ? 'Updating…' : checkoutLabel;
    checkoutBar?.setAttribute('aria-busy', String(pendingUpdates > 0));
  };
  const reserveCheckoutSpace = () => {
    if (checkoutBar) document.documentElement.style.setProperty('--cart-checkout-height', `${Math.ceil(checkoutBar.getBoundingClientRect().height)}px`);
  };
  if (checkoutBar) {
    reserveCheckoutSpace();
    if ('ResizeObserver' in window) new ResizeObserver(reserveCheckoutSpace).observe(checkoutBar);
  }
  form.addEventListener('submit', (event) => {
    if (pendingUpdates > 0) event.preventDefault();
  });
  form.querySelector('[data-cart-checkout-details]')?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { event.currentTarget.open = false; event.currentTarget.querySelector('summary')?.focus(); }
  });

  const emitCartUpdate = (cart) => {
    const detail = { cart };
    ['cart:updated', 'cart:change', 'cart:refresh'].forEach((eventName) => {
      window.dispatchEvent(new CustomEvent(eventName, { detail }));
      document.dispatchEvent(new CustomEvent(eventName, { detail }));
    });
  };

  const hasUnrenderedCartItem = (cart) => {
    const renderedKeys = new Set(Array.from(cartPage.querySelectorAll('[data-cart-line][data-line-key]')).map((line) => line.dataset.lineKey));
    return (cart.items || []).some((item) => !renderedKeys.has(item.key));
  };

  const getDisplayLineValues = (line, item = null) => {
    const quantity = Number(item?.quantity ?? line.dataset.lineQuantity ?? 0);
    const linePrice = Number(item?.final_line_price ?? item?.line_price ?? line.dataset.baseLinePrice ?? 0);
    const finalUnit = Number(item?.final_price ?? line.dataset.baseUnit ?? (quantity > 0 ? linePrice / quantity : 0));
    const originalUnit = Number(item?.original_price ?? line.dataset.originalUnit ?? finalUnit);
    const compareUnit = Number(line.dataset.compareUnit || 0);
    const displayUnit = finalUnit;
    const baselineUnit = Math.max(compareUnit, originalUnit);
    const discounted = baselineUnit > displayUnit && baselineUnit > 0 && quantity > 0;
    const discountPercentValue = discounted ? Math.round(((baselineUnit - displayUnit) * 100) / baselineUnit) : 0;
    const compareTotal = baselineUnit * quantity;
    return { quantity, linePrice, finalUnit: displayUnit, baselineUnit, compareTotal, discountPercentValue, discounted };
  };

  const updateLinePrices = (line, item = null) => {
    const values = getDisplayLineValues(line, item);
    line.querySelector('[data-line-price]').textContent = formatCartMoney(values.linePrice, currency);
    const compareNode = line.querySelector('[data-line-compare]');
    const discountNode = line.querySelector('[data-line-discount]');
    const discountPercent = line.querySelector('[data-line-discount-percent]');
    if (compareNode) {
      compareNode.textContent = formatCartMoney(values.compareTotal, currency);
      compareNode.hidden = !values.discounted;
    }
    if (discountNode) discountNode.hidden = !values.discounted;
    if (discountPercent) discountPercent.textContent = String(values.discountPercentValue);
  };

  const updateSummary = (cart = null) => {
    const itemsByKey = new Map((cart?.items || []).map((item) => [item.key, item]));
    let retailTotal = 0;
    let displaySubtotal = 0;
    cartPage.querySelectorAll('[data-cart-line]').forEach((line) => {
      const item = itemsByKey.get(line.dataset.lineKey);
      if (cart && !item) return;
      const values = getDisplayLineValues(line, item || null);
      displaySubtotal += values.linePrice;
      retailTotal += values.discounted ? values.compareTotal : values.linePrice;
    });
    retailTotal = Math.max(retailTotal, Number(cart?.original_total_price || 0));
    const subtotal = Number(cart?.total_price ?? displaySubtotal);
    const savings = Math.max(0, retailTotal - subtotal);
    const retailNode = cartPage.querySelector('[data-cart-retail]');
    const compareRow = cartPage.querySelector('[data-cart-compare]');
    const compareAmount = cartPage.querySelector('[data-cart-compare-amount]');
    const savingsRow = cartPage.querySelector('.cart-savings');
    const savingsNode = cartPage.querySelector('[data-cart-savings]');
    const subtotalNode = cartPage.querySelector('[data-cart-subtotal]');
    const discountsNode = cartPage.querySelector('[data-cart-discounts]');
    if (retailNode) retailNode.textContent = formatCartMoney(retailTotal, currency);
    if (compareAmount) compareAmount.textContent = formatCartMoney(retailTotal, currency);
    if (compareRow) compareRow.hidden = savings <= 0;
    if (savingsNode) savingsNode.textContent = formatCartMoney(savings, currency);
    if (savingsRow) savingsRow.hidden = savings <= 0;
    if (subtotalNode) subtotalNode.textContent = formatCartMoney(subtotal, currency);
    if (checkoutBar && cart) checkoutBar.hidden = cart.item_count === 0;
    if (discountsNode) {
      discountsNode.replaceChildren(...(cart?.cart_level_discount_applications || []).map((discount) => {
        const row = document.createElement('p');
        row.className = 'cart-discount-note';
        const title = document.createElement('span');
        title.textContent = discount.title || 'Discount applied';
        const amount = document.createElement('b');
        amount.textContent = `-${formatCartMoney(discount.total_allocated_amount || 0, currency)}`;
        row.append(title, amount);
        return row;
      }));
    }
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart?.item_count || cartPage.querySelectorAll('[data-cart-line]').length || 0; });
  };

  const setQuantity = async (line, quantity) => {
    if (line.classList.contains('is-updating')) return;
    const nextQuantity = Math.max(0, Number(quantity || 0));
    const input = line.querySelector('[data-cart-quantity-input]');
    const previousQuantity = Number(line.dataset.lineQuantity || 0);
    pendingUpdates += 1;
    syncCheckoutState();
    line.classList.add('is-updating');
    line.querySelectorAll('button,input,a').forEach((control) => { control.setAttribute('aria-disabled', 'true'); });
    if (input) input.value = String(nextQuantity);
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.dataset.lineKey, quantity: nextQuantity }),
      });
      if (!response.ok) throw new Error('Unable to update cart');
      const cart = await response.json();
      const item = (cart.items || []).find((cartItem) => cartItem.key === line.dataset.lineKey);
      if (!item || item.quantity === 0) {
        line.remove();
      } else {
        if (input) input.value = String(item.quantity);
        line.dataset.lineQuantity = String(item.quantity);
        updateLinePrices(line, item);
      }
      updateSummary(cart);
      emitCartUpdate(cart);
      if ((cart.item_count || 0) === 0 || hasUnrenderedCartItem(cart)) {
        window.setTimeout(() => window.location.reload(), 120);
      }
    } catch (error) {
      if (input) input.value = String(previousQuantity);
      showCartToast(document.documentElement.lang.startsWith('zh') ? '购物车更新失败，请重试' : 'Cart update failed. Please try again.');
    } finally {
      pendingUpdates -= 1;
      syncCheckoutState();
      line.classList.remove('is-updating');
      line.querySelectorAll('button,input,a').forEach((control) => { control.removeAttribute('aria-disabled'); });
    }
  };

  form.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-quantity-minus],[data-cart-quantity-plus]');
    if (!button) return;
    const line = button.closest('[data-cart-line]');
    const input = line?.querySelector('[data-cart-quantity-input]');
    if (!line || !input) return;
    const current = Number(input.value || 0);
    setQuantity(line, button.matches('[data-cart-quantity-plus]') ? current + 1 : current - 1);
  });

  form.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity-input]');
    if (!input) return;
    const line = input.closest('[data-cart-line]');
    if (line) setQuantity(line, input.value);
  });

  // Reconcile a just-claimed product discount on the first cart render. Shopify
  // applies the code at checkout, so the cart UI also shows the expected price
  // immediately while the discount cookie is being carried to checkout.
  cartPage.querySelectorAll('[data-cart-line]').forEach((line) => updateLinePrices(line));
  updateSummary();
});

document.querySelectorAll('[data-product-section]').forEach((section) => {
  const json = section.querySelector('[data-product-variants]');
  const variantSelect = section.querySelector('[data-variant-select]');
  const variantChoices = [...section.querySelectorAll('[data-variant-choice]')];
  const price = section.querySelector('[data-product-price]');
  const shippingNote = section.querySelector('[data-product-shipping]');
  const priceWrap = section.querySelector('[data-product-price-wrap]');
  const comparePrice = section.querySelector('[data-product-compare]');
  const priceDiscount = section.querySelector('[data-price-discount]');
  const priceDiscountPercent = section.querySelector('[data-price-discount-percent]');
  const addDiscount = section.querySelector('[data-add-discount]');
  const addDiscountPercent = section.querySelector('[data-add-discount-percent]');
  const stickyPrice = section.querySelector('[data-sticky-price]');
  const stickyComparePrice = section.querySelector('[data-sticky-compare]');
  const stickyVariant = section.querySelector('[data-sticky-variant]');
  const stickyAddDiscount = section.querySelector('[data-sticky-add-discount]');
  const stickyAddDiscountPercent = section.querySelector('[data-sticky-add-discount-percent]');
  const productCurrency = section.dataset.productCurrency || 'USD';
  const addButton = section.querySelector('[data-primary-add]');
  const stickyButton = section.querySelector('[data-sticky-add]');
  const addLabel = section.querySelector('[data-add-label]');
  const stickyLabel = section.querySelector('[data-sticky-label]');
  const stickyBar = section.querySelector('[data-sticky-purchase]');
  const productQuantityInput = section.querySelector('[data-product-quantity-input]');
  const productQuantityMinus = section.querySelector('[data-product-quantity-minus]');
  const productQuantityPlus = section.querySelector('[data-product-quantity-plus]');
  const mediaPanels = [...section.querySelectorAll('[data-product-media]')];
  const mediaThumbs = [...section.querySelectorAll('[data-gallery-thumb]')];
  const thumbsTrack = section.querySelector('.product-gallery__thumbs');
  const thumbsWrap = section.querySelector('[data-thumbs-wrap]');
  const galleryCounter = section.querySelector('[data-gallery-counter]');
  const swipeHint = section.querySelector('[data-swipe-hint]');
  const lightbox = section.querySelector('[data-product-lightbox]');
  const lightboxImage = section.querySelector('[data-lightbox-image]');
  let variants = [];
  try { variants = JSON.parse(json?.textContent || '[]'); } catch (error) { variants = []; }

  const setProductQuantity = (value) => {
    if (!productQuantityInput) return;
    const nextQuantity = Math.max(1, Math.floor(Number(value) || 1));
    productQuantityInput.value = String(nextQuantity);
  };
  productQuantityMinus?.addEventListener('click', () => setProductQuantity(Number(productQuantityInput?.value || 1) - 1));
  productQuantityPlus?.addEventListener('click', () => setProductQuantity(Number(productQuantityInput?.value || 1) + 1));
  productQuantityInput?.addEventListener('change', () => setProductQuantity(productQuantityInput.value));

  const stageElement = section.querySelector('.product-gallery__stage');

  const showMedia = (mediaId) => {
    if (!mediaId || mediaPanels.length === 0) return;
    const id = String(mediaId);
    const target = mediaPanels.find((panel) => panel.dataset.mediaId === id);
    if (!target) return;
    if (stageElement && !target.classList.contains('is-active')) {
      // Keep the stage at its current height until the incoming image is
      // decoded, so the thumbnails row never jumps while lazy images load.
      const incomingImage = target.querySelector('img');
      const needsPlaceholder = Boolean(incomingImage) && !(incomingImage.complete && incomingImage.naturalWidth > 0);
      if (needsPlaceholder) {
        stageElement.style.minHeight = `${stageElement.offsetHeight}px`;
        stageElement.classList.add('is-loading');
        const settle = () => {
          if (!stageElement.classList.contains('is-loading')) return;
          stageElement.classList.remove('is-loading');
          stageElement.style.minHeight = '';
          incomingImage.removeEventListener('load', settle);
          incomingImage.removeEventListener('error', settle);
        };
        incomingImage.addEventListener('load', settle, { once: true });
        incomingImage.addEventListener('error', settle, { once: true });
        window.setTimeout(settle, 8000);
      }
    }
    mediaPanels.forEach((panel) => {
      const active = panel === target;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
      if (!active) panel.querySelectorAll('video').forEach((video) => video.pause());
    });
    mediaThumbs.forEach((thumb) => {
      const active = thumb.dataset.mediaId === id;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
      if (active) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    if (galleryCounter) {
      const index = mediaPanels.findIndex((panel) => panel.dataset.mediaId === id);
      if (index > -1) galleryCounter.textContent = `${index + 1} / ${mediaPanels.length}`;
    }
  };

  mediaThumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId)));

  const stepMedia = (offset) => {
    if (mediaPanels.length < 2) return;
    const current = mediaPanels.findIndex((panel) => panel.classList.contains('is-active'));
    const next = ((current < 0 ? 0 : current) + offset + mediaPanels.length) % mediaPanels.length;
    showMedia(mediaPanels[next].dataset.mediaId);
  };
  section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => stepMedia(-1));
  section.querySelector('[data-gallery-next]')?.addEventListener('click', () => stepMedia(1));

  const thumbsScrollBy = (offset) => thumbsTrack?.scrollBy({ left: offset * Math.max(thumbsTrack.clientWidth * 0.8, 200), behavior: 'smooth' });
  section.querySelector('[data-thumbs-prev]')?.addEventListener('click', () => thumbsScrollBy(-1));
  section.querySelector('[data-thumbs-next]')?.addEventListener('click', () => thumbsScrollBy(1));
  const updateThumbsEdges = () => {
    if (!thumbsWrap || !thumbsTrack) return;
    const overflow = thumbsTrack.scrollWidth - thumbsTrack.clientWidth > 4;
    thumbsWrap.classList.toggle('is-scrollable', overflow);
    thumbsWrap.classList.toggle('is-at-start', !overflow || thumbsTrack.scrollLeft <= 4);
    thumbsWrap.classList.toggle('is-at-end', !overflow || thumbsTrack.scrollLeft + thumbsTrack.clientWidth >= thumbsTrack.scrollWidth - 4);
  };
  thumbsTrack?.addEventListener('scroll', updateThumbsEdges, { passive: true });
  window.addEventListener('resize', updateThumbsEdges);
  updateThumbsEdges();

  if (swipeHint) {
    const stageElement = section.querySelector('.product-gallery__stage');
    const hideSwipeHint = () => {
      swipeHint.classList.add('is-hidden');
      stageElement?.removeEventListener('pointerdown', hideSwipeHint);
    };
    stageElement?.addEventListener('pointerdown', hideSwipeHint, { passive: true });
    window.setTimeout(hideSwipeHint, 6000);
  }

  if (stageElement && mediaPanels.length > 1) {
    let touchStartX = null;
    stageElement.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0]?.clientX ?? null;
    }, { passive: true });
    stageElement.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const deltaX = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      touchStartX = null;
      if (Math.abs(deltaX) < 44) return;
      stepMedia(deltaX < 0 ? 1 : -1);
    }, { passive: true });
  }

  section.querySelectorAll('[data-gallery-open]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!lightbox || !lightboxImage) return;
      const sourceImage = button.querySelector('img');
      lightboxImage.src = button.dataset.zoomSrc || sourceImage?.currentSrc || sourceImage?.src || '';
      lightboxImage.alt = sourceImage?.alt || '';
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
    });
  });
  section.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });

  const updateVariant = (variant, mediaId, updateUrl = true) => {
    if (!variantSelect || !variant) return;
    const targetOption = variant ? [...variantSelect.options].find((option) => option.value === String(variant.id)) : null;
    const available = Boolean(variant?.available && targetOption);
    if (targetOption) variantSelect.value = targetOption.value;
    if (stickyVariant) stickyVariant.textContent = variant.title || '';
    variantChoices.forEach((choice) => {
      const active = choice.dataset.variantId === String(variant.id);
      choice.classList.toggle('is-active', active);
      choice.setAttribute('aria-pressed', String(active));
    });
    const formattedPrice = targetOption?.dataset.price;
    if (formattedPrice && price) price.textContent = formattedPrice;
    if (formattedPrice && stickyPrice) stickyPrice.textContent = formattedPrice;
    const variantPrice = Number(variant.price || 0);
    if (shippingNote) shippingNote.textContent = productCurrency === 'USD' && variantPrice >= 4900
      ? 'FREE SHIPPING · On this item'
      : 'FREE SHIPPING ON ORDERS US$49+';
    const variantComparePrice = Number(variant.compare_at_price || 0);
    const percentage = variantComparePrice > variantPrice && variantComparePrice > 0
      ? Math.round(((variantComparePrice - variantPrice) * 100) / variantComparePrice)
      : 0;
    const formattedComparePrice = percentage > 0
      ? targetOption?.dataset.comparePrice || formatCartMoney(variantComparePrice, productCurrency)
      : '';
    const isDiscounted = percentage > 0 && Boolean(formattedComparePrice);
    if (priceWrap) priceWrap.classList.toggle('is-sale', isDiscounted);
    if (comparePrice) {
      comparePrice.textContent = formattedComparePrice;
      comparePrice.hidden = !isDiscounted;
    }
    if (priceDiscount) priceDiscount.hidden = !isDiscounted;
    if (priceDiscountPercent) priceDiscountPercent.textContent = String(percentage);
    if (addDiscount) addDiscount.hidden = !(isDiscounted && available);
    if (addDiscountPercent) addDiscountPercent.textContent = String(percentage);
    if (stickyComparePrice) {
      stickyComparePrice.textContent = formattedComparePrice;
      stickyComparePrice.hidden = !isDiscounted;
    }
    if (stickyAddDiscount) stickyAddDiscount.hidden = !(isDiscounted && available);
    if (stickyAddDiscountPercent) stickyAddDiscountPercent.textContent = String(percentage);
    if (addButton) addButton.disabled = !available;
    if (stickyButton) stickyButton.disabled = !available;
    if (addLabel) addLabel.textContent = available ? section.dataset.addText : section.dataset.soldText;
    if (stickyLabel) stickyLabel.textContent = available ? section.dataset.stickyAddText : section.dataset.soldText;
    showMedia(mediaId || targetOption?.dataset.mediaId || variant.featured_media?.id);
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  variantChoices.forEach((choice) => {
    choice.addEventListener('click', () => {
      const variant = variants.find((item) => String(item.id) === choice.dataset.variantId);
      updateVariant(variant, choice.dataset.mediaId);
    });
  });
  variantSelect?.addEventListener('change', () => {
    const variant = variants.find((item) => String(item.id) === variantSelect.value);
    updateVariant(variant, variantSelect.selectedOptions[0]?.dataset.mediaId);
  });
  if (variantSelect) {
    const initialVariant = variants.find((item) => String(item.id) === variantSelect.value);
    const initialChoice = variantChoices.find((choice) => choice.dataset.variantId === variantSelect.value);
    updateVariant(initialVariant, initialChoice?.dataset.mediaId, false);
  }

  if (stickyBar && addButton) {
    const setStickyVisibility = (visible) => {
      stickyBar.classList.toggle('is-visible', visible);
      stickyBar.setAttribute('aria-hidden', String(!visible));
    };
    stickyButton?.addEventListener('click', () => {
      if (typeof window.clarity === 'function') window.clarity('event', 'sticky_add_to_cart_click');
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => setStickyVisibility(!entry.isIntersecting), { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      observer.observe(addButton);
    } else {
      setStickyVisibility(window.scrollY > addButton.getBoundingClientRect().bottom + window.scrollY);
    }
  }
});
